
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.735 3.574l-3.075-.47L5.283.164c-.103-.219-.463-.219-.566 0L3.34 3.105l-3.075.47a.313.313 0 00-.176.528l2.234 2.293-.528 3.24a.313.313 0 00.46.325L5 8.44l2.746 1.52a.313.313 0 00.46-.324l-.528-3.24L9.91 4.102a.313.313 0 00-.176-.529z","fill":"#B8C3CD","fill-rule":"nonzero"}})])
          )
        }
      }
    